import { DecisionTreeTable } from '../domain/table/decision-tree-table';
import { DecisionTree } from '../domain/tree/decision-tree';
import { DecisionTreeTableColumnType } from '../domain/table/decision-tree-table-column';
import { useDecisionTreeStore } from '../dal/decision-tree-store';
import { BinningOption } from '../interfaces';

const Table = () => {

    const setDecisionTree = useDecisionTreeStore(store => store.setDecisionTree);

    const columnsRewrittenTypes = useDecisionTreeStore(store => store.columnsRewrittenTypes);
    const setColumnsRewrittenTypes = useDecisionTreeStore(store => store.setColumnsRewrittenTypes);

    const forceBinningColumns = useDecisionTreeStore(store => store.forceBinningColumns);
    const setForceBinningColumns = useDecisionTreeStore(store => store.setForceBinningColumns);

    const excludedColumns = useDecisionTreeStore(store => store.excludedColumns);
    const setExcludedColumns = useDecisionTreeStore(store => store.setExcludedColumns);

    const csv = useDecisionTreeStore(store => store.csv);

    const decisionTreeTable = useDecisionTreeStore(store => store.decisionTreeTable);
    const setDecisionTreeTable = useDecisionTreeStore(store => store.setDecisionTreeTable);

    const binningByDepth = useDecisionTreeStore(store => store.binningByDepth);
    const setBinningByDepth = useDecisionTreeStore(store => store.setBinningByDepth);

    const binningGroupsCount = useDecisionTreeStore(store => store.binningGroupsCount);
    const setBinningGroupsCount = useDecisionTreeStore(store => store.setBinningGroupsCount);

    const onExcludeChange = (header: string, isChecked: boolean) => {

        const set = new Set(excludedColumns);

        if(set.has(header)) {
            if(!isChecked) {
                set.delete(header);
            }
        }
        else{
            if(isChecked) {
                set.add(header);
            }
        }

        const _excluded = [...set];
        setExcludedColumns(_excluded);
        setDecisionTreeTable(csv.trim() === '' ? null : new DecisionTreeTable(
            csv,
            _excluded,
            forceBinningColumns,
            columnsRewrittenTypes,
            binningByDepth,
            binningGroupsCount
        ));

        setDecisionTree(csv.trim() === '' ? null : new DecisionTree(
            csv,
            _excluded,
            forceBinningColumns,
            columnsRewrittenTypes,
            binningByDepth,
            binningGroupsCount
        ));
    };

    const onForceBinningChange = (header: string, option: BinningOption) => {

        const copy = new Map(forceBinningColumns);

        copy.set(header, option);

        setForceBinningColumns(copy);

        setDecisionTreeTable(csv.trim() === '' ? null : new DecisionTreeTable(
            csv,
            excludedColumns,
            copy,
            columnsRewrittenTypes,
            binningByDepth,
            binningGroupsCount
        ));

        setDecisionTree(csv.trim() === '' ? null : new DecisionTree(
            csv,
            excludedColumns,
            copy,
            columnsRewrittenTypes,
            binningByDepth,
            binningGroupsCount
        ));
    };

    const onTypeChange = (header: string, newType: DecisionTreeTableColumnType) => {
        const copy = new Map(columnsRewrittenTypes);
        copy.set(header, newType);
        setColumnsRewrittenTypes(copy);
        setDecisionTreeTable(csv.trim() === '' ? null : new DecisionTreeTable(
            csv,
            excludedColumns,
            forceBinningColumns,
            copy,
            binningByDepth,
            binningGroupsCount
        ));
        setDecisionTree(csv.trim() === '' ? null : new DecisionTree(
            csv,
            excludedColumns,
            forceBinningColumns,
            copy,
            binningByDepth,
            binningGroupsCount
        ));
    };

    const onBinningByDepthChange = (header: string, isChecked: boolean) => {

        const set = new Set(binningByDepth);

        if(set.has(header)) {
            if(isChecked) {
                set.delete(header);
            }
        }
        else{
            if(!isChecked) {
                set.add(header);
            }
        }

        const _binningByDepth = [...set];
        setBinningByDepth(_binningByDepth);

        setDecisionTreeTable(csv.trim() === '' ? null : new DecisionTreeTable(
            csv,
            excludedColumns,
            forceBinningColumns,
            columnsRewrittenTypes,
            _binningByDepth,
            binningGroupsCount
        ));

        setDecisionTree(csv.trim() === '' ? null : new DecisionTree(
            csv,
            excludedColumns,
            forceBinningColumns,
            columnsRewrittenTypes,
            _binningByDepth,
            binningGroupsCount
        ));
    };

    const onBinningGroupsCountChange = (header: string, count: number) => {

        const copy = new Map(binningGroupsCount);

        copy.set(header, count);

        setBinningGroupsCount(copy);

        setDecisionTreeTable(csv.trim() === '' ? null : new DecisionTreeTable(
            csv,
            excludedColumns,
            forceBinningColumns,
            columnsRewrittenTypes,
            binningByDepth,
            copy
        ));

        setDecisionTree(csv.trim() === '' ? null : new DecisionTree(
            csv,
            excludedColumns,
            forceBinningColumns,
            columnsRewrittenTypes,
            binningByDepth,
            copy
        ));
    };

    return (
        <>
            { decisionTreeTable?.draw(onExcludeChange, onForceBinningChange, onTypeChange, onBinningByDepthChange, onBinningGroupsCountChange) }
        </>
    )
};

export default Table;